import { useAllVisits } from '../../api/queries';
import { usePracticeInfo, useVisitModals } from '../../hooks/useVisitModals';
import { VisitListPage } from '../../components/visits/VisitListPage';

export function UpcomingVisitsPage() {
  const { hasActivePlan } = usePracticeInfo();
  const { data: visitsData, isLoading } = useAllVisits(hasActivePlan);
  const { openDetail, modals } = useVisitModals();

  return (
    <>
      <VisitListPage
        visits={visitsData?.upcomingVisits || []}
        isLoading={isLoading}
        emptyMessage="No upcoming visits. Use the Schedule Visit button above to create one."
        onVisitClick={openDetail}
        heading={<h2><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: '-2px', marginRight: '0.35rem' }}><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>Upcoming Visits</h2>}
      />
      {modals}
    </>
  );
}
